import React from 'react';
import MenuItem from 'app/shared/layout/menus/menu-item';

import { NavDropdown } from './menu-components';

export const EntitiesMenu = props => (
  <NavDropdown icon="th-list" name="Entities" id="entity-menu" data-cy="entity" style={{ maxHeight: '80vh', overflow: 'auto' }}>
    <>{/* to avoid warnings when empty */}</>
    <MenuItem icon="asterisk" to="/aidas-organisation">
      Organisation
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-customer">
      Customer
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-project">
      Project
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-object">
      Object
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-vendor">
      Vendor
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-user">
      User
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-upload">
      Upload
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-properties">
      Properties
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-project-property">
      Project Property
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-object-property">
      Object Property
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-upload-meta-data">
      Upload Meta Data
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-authority">
      Authorities
    </MenuItem>
    <MenuItem icon="asterisk" to="/aidas-user-aidas-object-mapping">
      Aidas User Aidas Object Mapping
    </MenuItem>
    {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
  </NavDropdown>
);
